<script lang="ts" setup>
  import { StoreLayout, AccountLayout } from '@storefront/components';
  import type { Complaint, ComplaintItem, ComplaintAndRefundAddress } from '@storefront/resources';

  defineOptions({
    layout: [StoreLayout, AccountLayout],
    inheritAttrs: false,
  });

  interface Props {
    complaint: Complaint;
    complaintReturnAddress: ComplaintAndRefundAddress;
    items: ComplaintItem[];
  }

  defineProps<Props>();
</script>
<template>
  <AccountMobileNavigation :href="$route('web.account.complaint.index')">
    {{ $t('SHOP.ACCOUNT.HEADER.COMPLAINT_DETAILS') }}
  </AccountMobileNavigation>
  <ComplaintDetailsView v-bind="$props" />

  <RouterView />
</template>
